/* istanbul ignore file */

export const ATTRIBUTE_BUNDLE_GROUP_PHYSICAL_ITEM = 'hasPhysicalItem';
export type ATTRIBUTE_BUNDLE_GROUP_PHYSICAL_ITEM =
  typeof ATTRIBUTE_BUNDLE_GROUP_PHYSICAL_ITEM;

export type ATTRIBUTE_KEY = ATTRIBUTE_BUNDLE_GROUP_PHYSICAL_ITEM;
